import axiosClient from "../../../../../../axiosClient"

export default async (preCheckId) => {
    const result = await axiosClient.get(`/pre-check-pre-adverse-action-emails/${preCheckId}`)
    return result.data
}
